import AutoStepScroll from './auto-step-scroll.component'

export default AutoStepScroll